import { SortableTh, SortingDirection, Table, TableWrapper, Tbody, Td, Th, Thead, Tr } from '@components/core-ui/Table';
import { useSortState } from '@components/core-ui/Table/hooks/useSortState';
import { getAmericanTime } from '@helpers/getAmericanTimezone';
import { sortTeamMembers, TTeamMemberSortField } from '@helpers/sortTeamMembers';
import { routes } from '@routes';
import { FindOneTeamResponseDto } from 'app/API';
import { Link } from 'react-router-dom';
import { CellContent } from './styles/CellContent';
import { Wrapper } from './styles/Wrapper';

type TProps = {
  team: FindOneTeamResponseDto;
};

export const TeamMembersTable = ({ team }: TProps) => {
  const { sortingField, sortingReverse, toggleSort } = useSortState<TTeamMemberSortField | ''>('');
  const members = sortTeamMembers(team.Members ?? [], sortingField, sortingReverse);

  return (
    <Wrapper>
      <TableWrapper>
        <Table>
          <Thead>
            <Tr>
              <Th style={{ width: '1%' }}>#</Th>
              <SortableTh style={{ width: '20%' }} onClick={() => toggleSort('name')}>
                Name
                {sortingField === 'name' && <SortingDirection reverse={sortingReverse} />}
              </SortableTh>
              <Th style={{ width: '50%' }}>Contact</Th>
              <SortableTh style={{ width: '1%' }} onClick={() => toggleSort('createdAt')}>
                Created
                {sortingField === 'createdAt' && <SortingDirection reverse={sortingReverse} />}
              </SortableTh>
            </Tr>
          </Thead>
          <Tbody>
            {members.map((data, index) => (
              <Tr key={data.id ?? index}>
                <Td>
                  <CellContent>{index + 1}</CellContent>
                </Td>
                <Td>
                  <CellContent>
                    <Link to={routes.adminUserDetails.make(data.User.id)}>
                      {data.User.name} {data.User.lastname}
                    </Link>
                  </CellContent>
                </Td>
                <Td>
                  <CellContent>
                    <span style={{ display: 'block' }}>{data.User.email}</span>
                    <span style={{ display: 'block' }}>{data.User.phone}</span>
                  </CellContent>
                </Td>
                <Td>
                  <CellContent>{getAmericanTime(data.User?.createdAt ?? 0)}</CellContent>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableWrapper>
    </Wrapper>
  );
};
